// extracted by mini-css-extract-plugin
module.exports = {"sort":"OW","selected":"PW","disabled":"QW"};